import receiptResponseQuery from '../../queries/product/AssemblyReceiptResponseQuery.graphql';
import { DocumentNode } from 'graphql';

const AssemblyReceipt: { receiptResponse: DocumentNode } = {
  receiptResponse: receiptResponseQuery,
};

export default AssemblyReceipt;
